export default __webpack_public_path__ + "static/media/webinarBox4.282fc2cf.png";